export const EventBatchSize = 10
export const EventFlushInterval = 1000
